import { useSyncExternalStore } from 'react';
import { walletStore, type WalletState } from '../lib/wallet';

/**
 * Read the global wallet state. Re-renders on any state change.
 * Multiple components share the same store — no provider needed.
 */
export function useWallet(): WalletState {
  return useSyncExternalStore(walletStore.subscribe, walletStore.get);
}

/** Convenience: account address if connected, else null. */
export function useAccount(): string | null {
  const w = useWallet();
  return w.status === 'connected' ? w.address : null;
}

/** Convenience: signer-bound contracts if connected, else null. */
export function useSignerContracts() {
  const w = useWallet();
  return w.status === 'connected' ? w.contracts : null;
}
